import React from 'react';

import BuildingsTable from './BuildingsTable';

import {
	closeModalPreservingOptIn,
} from './CustomModal';

import {
	getSession,
} from 'Vulture/Session';

import {
	isNarrowScoped,
} from 'Vulture/Permissions';

import {
	setBuildingSystemGroup,
} from 'Vulture/Buildings';

class BuildingsView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			buildingsDataArray:   props.buildingsDataArray,
			confirmModal:        false,
			confirmModalContent: '',
		};
	}

	componentDidMount() {
		document.body.classList.add('buildings-page-open');
	}

	componentWillUnmount() {
		document.body.classList.remove('buildings-page-open');
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps.buildingsDataArray) !== JSON.stringify(this.props.buildingsDataArray)) {
			this.setState({
				buildingsDataArray: this.props.buildingsDataArray,
			});
		}
	}

	// Persists a building's system group immediately through /v1/buildings and
	// re-fetches. The row is updated optimistically first so the chip reacts at once;
	// on failure the previous group is put back (the re-fetch alone would not, since
	// componentDidUpdate only resyncs when the parent's array actually changes).
	persistSystemGroup(buildingIndex, systemGroupUUID) {
		const {
			app,
		} = this.props;

		const {
			buildingsDataArray,
		} = this.state;

		const building = buildingsDataArray[buildingIndex];
		const buildingUUID = building.m1Key.split('.')[1];
		const previousSystemGroup = building.system_group;

		const newBuildingsDataArray = [...buildingsDataArray,];
		newBuildingsDataArray[buildingIndex] = {
			...building,
			system_group: systemGroupUUID || '',
		};

		this.setState({
			buildingsDataArray: newBuildingsDataArray,
		}, () => {
			setBuildingSystemGroup(buildingUUID, systemGroupUUID)
				.then((res) => {
					if (res && res.error) {
						// Restore and stop: a re-fetch after a failed write is at best
						// redundant and, if the network is down, feeds the error object
						// into the table as rows.
						//
						// Only this row's system_group goes back, against whatever state
						// is current rather than the snapshot taken before the request:
						// restoring the whole row would discard an edit or refresh that
						// landed meanwhile, and restoring the whole array would undo
						// another row's successful chip.
						this.setState((state) => ({
							buildingsDataArray: state.buildingsDataArray.map((row) => {
								if (row.m1Key !== building.m1Key) {
									return row;
								}

								return {
									...row,
									system_group: previousSystemGroup,
								};
							}),
						}));

						if (typeof app.setNetworkErrorModal === 'function') {
							app.setNetworkErrorModal(false, res.message);
						}

						return;
					}

					app.fetchAccountBuildings();
				});
		});
	}

	unassignGroup(building) {
		const {
			buildingsDataArray,
		} = this.state;

		const buildingIndex = buildingsDataArray.findIndex(b => b.m1Key === building.m1Key);
		if (buildingIndex === -1) return;

		this.persistSystemGroup(buildingIndex, null);
	}

	toggleSelectAllRows(areAllRowsChecked) {
		const {
			buildingsDataArray,
		} = this.state;

		const allRowsSelected = buildingsDataArray.reduce((previous, current) => {
			return previous && current.isChecked;
		}, true);
		const newBuildingsDataArray = buildingsDataArray;

		const newSelectedBuildings = [];
		newBuildingsDataArray.forEach((element) => {
			element.isChecked = !allRowsSelected;
			if (!areAllRowsChecked) {
				newSelectedBuildings.push(element.uuid);
			}
		});

		this.setState({
			buildingsDataArray: newBuildingsDataArray,
		});
	}

	// Building writes no longer travel in the global pendingChanges bag, so this modal
	// has no claim on it.
	closeModal() {
		closeModalPreservingOptIn(this.props.app, { keepPendingChanges: true, });
	}

	render() {
		const {
			app,
			fd,
			systemGroupUUID,
		} = this.props;

		const {
			buildingsDataArray,
		} = this.state;

		let confirmModal = '';
		if (this.state.confirmModal === true) {
			confirmModal = (
				<div className="confirm-modal-container">
					<div className="confirm-modal-content">
						{this.state.confirmModalContent}
					</div>
				</div>
			);
		}

		const groupsToHide = [];

		if (isNarrowScoped()) {
			for (const [ m1Key, m1Data, ] of Object.entries(fd)) {
				if (m1Key.startsWith('system_group.')) {
					groupsToHide.push(m1Key);

					for (const systemKey of Object.keys(m1Data)) {
						if (systemKey.startsWith('system.') || systemKey.startsWith('system_group.')) {
							if (fd[systemKey]) {
								groupsToHide.pop();
								break;
							}
						}
					}
				}
			}
		}

		const columns = Object.entries(fd)
			.filter(([ m1Key, ]) => {
				return !groupsToHide.includes(m1Key);
			})
			.filter(([ m1Key, ]) => {
				if (!systemGroupUUID) {
					return m1Key.startsWith('system_group.');
				}

				return m1Key === 'system_group.' + systemGroupUUID;
			})
			.reduce(((previous, [ m1Key, m1Val, ]) => {
				return {
					...previous,
					[m1Key]: m1Val.display_name,
				};
			}), {});

			buildingsDataArray.sort((a, b) => {
				const buildingNameA = (a.vals.buildingName || '').toLowerCase();
				const buildingNameB = (b.vals.buildingName || '').toLowerCase();
				if (buildingNameA < buildingNameB) {
					return -1;
				}
				if (buildingNameA > buildingNameB) {
					return 1;
				}
				return 0;
			});

		return (
			<>
				{confirmModal}
				<>
					<BuildingsTable
						array={buildingsDataArray}
						columnsToHide={[ 'columnToHide', ]}
						app={app}
						systemGroupUUID={systemGroupUUID}
						fd={fd}
						tableSettings={columns}
						buildingsView={this}
						closeModal={this.closeModal.bind(this)}
						toggleSelectAllRows={this.toggleSelectAllRows.bind(this)}
					/>
				</>
			</>
		);
	}
}

export default BuildingsView;